import type { HelpFile } from '../../types/help'
import { ServerUnavailableOverlayTestIds } from '../../../testids/ServerUnavailableOverlayTestIds'

export const serverUnavailableOverlayHelp: HelpFile = {
  docPage: '/docs/troubleshooting/server-unavailable',
  texts: {
    [ServerUnavailableOverlayTestIds.serverUnavailableOverlay]: 'The backend is unreachable — the application is unavailable until connectivity is restored.',
    [ServerUnavailableOverlayTestIds.serverUnavailableHeading]: null,
  },
}
